import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  ElementRef,
  Renderer2,
  Inject, SimpleChanges,
  OnDestroy,
  OnChanges,
} from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FulleSalemethodComponent } from "src/app/components/dialogs/fulle/fulle-salemethod/fulle-salemethod.component";
import { ProductService } from "src/app/services/api/product/product.service";
import { RubricService } from "src/app/services/api/rubric/rubric.service";
import { PointofsaleService } from "src/app/services/api/pointofsale/pointofsale.service";
import { MediaObserver } from "@angular/flex-layout";
import { ProdComponent } from "src/app/components/dialogs/prod/prod.component";
import { PanierService } from "src/app/services/manage/panier/panier.service";
import { ToolsService } from "../../../services/tools/tools.service";
import { ProdcatService } from "../../../services/api/prodcat/prodcat.service";
import { Router, ActivatedRoute } from "@angular/router";
import { panierAnim, titleBannerAnim } from "../../../models/consts/anims";
import { PreventLossAllComponent } from "../../dialogs/prevent-loss-all/prevent-loss-all.component";
import { Angulartics2GoogleAnalytics } from "angulartics2";
import { SalemethodService } from "src/app/services/api/salemethod/salemethod.service";
import { ClientOrdersService } from "src/app/services/apiclient/order/clientorders.service";
import { DialogsService } from "src/app/services/manage/dialogs/dialogs.service";
import { CurrencyService } from "src/app/services/manage/currency/currency.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ReplaceSpecialCharactersPipe } from "src/app/filters/replace-special-characters.pipe";
import { FulleSelectProductsTimeSlotComponent } from "../../dialogs/fulle/fulle-select-products-time-slot/fulle-select-products-time-slot.component";
import * as moment from "moment";
import * as _ from "lodash";
import { DOCUMENT } from "@angular/common";
import { ClientMerchantsService } from "src/app/services/apiclient/clientmerchants/clientmerchants.service";
import { AuthService } from 'src/app/services/auth/auth.service';
import { borneOrderService } from "src/app/services/borneOrder/borneOrder.service";
import { TranslateService } from "@ngx-translate/core";
import { BaseclientService } from "../../../services/apiclient/baseclient.service";
import { CssService } from "../../../services/css-service";
import { FullePointOfSaleService } from "src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service";
import { LogoAndBannerService } from "src/app/services/fulle/logoAndBanner/logoAndBanner.service";
import { PointOfSaleDetails } from "src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface";

@Component({
  selector: "app-fulle-product-mode-borne",
  templateUrl: "./fulle-product-mode-borne.component.html",
  styleUrls: ["./fulle-product-mode-borne.component.css"],
  animations: [panierAnim, titleBannerAnim],
  providers: [ReplaceSpecialCharactersPipe],
})
export class FulleProductModeBorneComponent implements OnInit, OnDestroy, OnChanges {
  // ======== Variables de DOM accessibles par @ViewChild ========
  @ViewChild("rubProdCont", { read: ElementRef }) rubProdCont: ElementRef | undefined; // Container des produits par rubrique
  @ViewChild("rubsComp") rubsComp: ElementRef | any; // Container principal des rubriques
  @ViewChild("rubsList") rubsList: ElementRef | any; // Liste des rubriques horizontales
  @ViewChild("rubsListFixed") rubsListFixed: ElementRef | any; // Liste des rubriques fixe en haut
  @ViewChild("basketComp") basketComp: ElementRef | any; // Composant du panier
  @ViewChild("main_container") main_container: ElementRef | any; // Conteneur principal de la page
  @ViewChild("searchProductInput") searchProductInput: ElementRef | any; // Input de recherche
  @ViewChild("Prodrubs") Prodrubs: ElementRef | any; // Bloc rubriques produits
  @ViewChild("ProdrubsFixed") ProdrubsFixed: ElementRef | any; // Bloc rubriques fixes
  @ViewChild('listRubrics') listRubrics: ElementRef | any; // Liste déroulante des rubriques (mobile)
  @ViewChild('listRubricsFixed') listRubricsFixed: ElementRef | any; // Liste fixe des rubriques (desktop)

  default_prod =
    "https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png";

  // ======== Données de session/localStorage ========
  currPos: any = this.tools.getStor("point_of_sale");
  currSM: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
  currBasket: any = this.tools.getStor(PanierService.TAG_STORAGE);
  currUserKey: any = this.tools.getStor("user_id");
  currIdMerchant: any = this.tools.getStor("id_merchant");

  urlParams: any;
  // ======== Observables / Streams de données ========
  rubrics$: any; // Toutes les rubriques (catégories de produits)
  displayRubrics: any; // Rubriques à afficher
  products$: any; // Tous les produits
  displayProducts: any; // Produits affichés
  categories$: any; // Catégories des produits (type formule, etc.)
  newRubricsDisplay$: any; // Rubriques filtrées (recherche, promo, etc.)
  // ======== Recherche de produit ========
  searchProductForm: FormGroup | any; // Formulaire de recherche
  findedProducts: any = null; // Produits trouvés par la recherche
  searchProductLoader = false; // Loader de la recherche
  showSearchInput = false; // Affichage de l'input de recherche
  // ======== Scroll et UI ========
  scrollRubsList = 0; // Position de scroll rubriques
  scrollRubsListFixed = 0; // Position de scroll rubriques fixe
  toggleRubBar = true; // Affichage de la barre de rubriques
  toggleBasket = true; // Affichage du panier (desktop)
  toggleBasketResp = true; // Affichage du panier (mobile)
  // ======== Gestion du temps et créneaux ========
  displayDay: any;
  displayHour: any;
  orderDateHour: any; // Date/heure sélectionnée pour la commande
  // ======== Loaders ========
  loader = true; // Loader principal
  loaderMessage: string | null = null;
  loaderpop = false; // Loader secondaire (ex: chargement popup)
  statusMessage: any = null; // Message de statut (ex: "chargement..." en popup)
  loaderTransparent = false; // Loader transparent pour certaines actions
  // ======== Dimensions de la fenêtre ========
  windowWidth: number = window.innerWidth;
  windowHeight: number = window.innerHeight;
  // ======== Observables / Subscriptions ========
  orderSub: any;
  prodCatSub: any;
  obserUser: any;
  obsergetProd: any;
  ObserLoaderProductSuggestion: any;
  // ======== Données utilisateur & logique métier ========
  user_: any = null;
  merchantClient: any; // Données du client connecté (pour promos / favoris)
  hoursOpen = null;
  popClosed = true; // Pour savoir si la popup produit est fermée
  // ======== Pagination et chargement de produits ========
  $limit_to = 50; // Nombre de produits à récupérer
  $limit_from = 0; // Index de départ
  $count = 0; // Total des produits récupérables
  $more_products_button = true; // Affichage du bouton "voir plus"
  scrollingElementProd: any; // Scroll produit pour détecter les interactions
  blockScrollRubrics = false; // Blocage du scroll automatique des rubriques
  closeSearch = false; // Flag pour cacher les résultats de recherche temporairement
  // ======== Données supplémentaires ========
  stocks: any = []; // Stocks en cours pour les produits
  pricePeriods: any = []; // Périodes de prix en cours (promos, etc.)
  mainCompPosition: number | undefined;
  titleBannerWidth: number | undefined;
  titleBannerFlag = false;
  // ======== Conditions affichage fleche slider rubrique ========
  sliderRubArrowLeft = true;
  sliderRubArrowRight = true;
  sliderRubFixedArrowLeft = true;
  sliderRubFixedArrowRight = true;
  rememberBasketPos: number | any;
  rememberRubsPos: number | undefined;
  OpenOnInitDialog = false;
  scrollPositionY: any;
  copyscrollPositionY: any;
  start: any;

  // temporaire
  id_webshop_route = '';

  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private prodApi: ProductService,
    private rubApi: RubricService,
    private posApi: PointofsaleService,
    public cssService: CssService,
    private smApi: SalemethodService,
    private orderApi: ClientOrdersService,
    public media: MediaObserver,
    private renderer: Renderer2,
    private panierMan: PanierService,
    private currencyMng: CurrencyService,
    public tools: ToolsService,
    public baseclientService: BaseclientService,
    private prodcatApi: ProdcatService,
    private router: Router,
    private route: ActivatedRoute,
    public myDials: DialogsService,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private formBuilder: FormBuilder,
    private ReplaceSpecialCharactersPipe: ReplaceSpecialCharactersPipe,
    @Inject(DOCUMENT) private document: Document,
    private clientMerchantApi: ClientMerchantsService,
    private authService: AuthService,
    private borneOrderService: borneOrderService,
    public translate: TranslateService,
    private fullePointOfSaleService: FullePointOfSaleService,
    private logoAndBannerService: LogoAndBannerService,

  ) {
    // Initialisation à la construction du composant
    this.getClient(); // récupération du client connecté (si présent)
    this.getObserGetProduct(); // observe le flux "get product"
    this.getObserLoaderProductSuggestion(); // observe le loader de suggestions
  }

  async ngOnInit(): Promise<void> {
    // Initialisation à l'ouverture de la page
    this.stocks = this.route.snapshot.data['stocks'];
    // Périodes de prix
    this.pricePeriods = this.route.snapshot.data['pricePeriods'];
    this.tools.removeStor('SuggestionsEnd');
    this.loaderTransparent = false;

    // on donne la possibilite d'utiliser les points fidelity
    //this.panierMan.setDialogFid();
    //analitycs
    this.initGoogleAnalytics();
    //ouverture du panier si existe
    if (this.currBasket && this.currBasket.length > 0) {
      // this.openBasket();
    }
    this.handleUrlParams(); // Récupère les paramètres d'URL
    this.createSearchProductForm(); // Crée le formulaire de recherche produit
    // ajoute les valeurs size au logo et la banniere
    this.logoAndBannerService.initLogoAndBannerDetails(this.currPos).then((enrichedPoint: PointOfSaleDetails) => {
      if (enrichedPoint) {
        this.currPos = enrichedPoint;
      }
    });
  }

  get getToggleTitle(): string {
    return this.titleBannerFlag ? "show" : "hide";
  }

  // ======== popup close back press stop navigation ========
  @HostListener('window: popstate')
  onPopState(): void {
    this.copyscrollPositionY = !this.toggleBasketResp ? null : this.copyscrollPositionY;
    // on efface si panier
    if (this.copyscrollPositionY) {
      setTimeout(() => {
        window.scrollTo({ top: this.copyscrollPositionY });
      }, 0);
    }
    if (this.tools.getOnPopState() && !this.tools.getOnPopState().openCheckAddress) {
      this.tools.getOnPopState().state && (this.tools.getOnPopState().currSmId) || !this.toggleBasketResp || !this.popClosed ? history.forward() : null;
    } else if (this.tools.getOnPopState() && this.tools.getOnPopState().openCheckAddress) {
      history.forward();
      window.location.reload();
    }
    this.checkPopOpen('close');
  }

  // ======== checkPopOpen ========
  checkPopOpen(data?: any) {
    this.popClosed = !data ? false : true;
    this.toggleBasketResp = true;
    setTimeout(() => {
      this.tools.setOnPopState();
    }, 0);
  }

  // ======== destruction observalbles ======== 
  ngOnDestroy(): void {
    // Nettoyage des subscriptions pour éviter les fuites mémoire
    if (this.orderSub) this.orderSub.unsubscribe();
    if (this.prodCatSub) this.prodCatSub.unsubscribe();
    if (this.obserUser) this.obserUser.unsubscribe();
    if (this.obsergetProd) this.obsergetProd.unsubscribe();
    if (this.ObserLoaderProductSuggestion) this.ObserLoaderProductSuggestion.unsubscribe();
  }

  /*
  * Cette méthode s'exécute à chaque redimensionnement de la fenêtre.
  * Elle met à jour la largeur et la hauteur de la fenêtre stockées localement,
  * puis met à jour l'affichage des flèches de navigation dans les rubriques.
  */
  @HostListener('window:resize')
  onResize() {
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;
    this.arrowsVisibility();
  }

  // ======== Initialisation de Google Analytics ========
  initGoogleAnalytics() {
    if (this.currPos) {
      const script1 = this.renderer.createElement('script');
      script1.src = "https://www.googletagmanager.com/gtag/js?id=" + this.currPos.webshopAnalyticsCode;
      this.renderer.appendChild(this.document.body, script1);
      const script2 = this.renderer.createElement('script');
      script2.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '` + this.currPos.webshopAnalyticsCode + `');`;
      this.renderer.appendChild(this.document.body, script2);
    }
  }

  // ======== Watcher de changements des @inputs ========
  // cet élément est en angular l'équialent d'un watcher qui vérifie que l'user est toujours connecté.
  // s'il ne l'est pas ça lance une déco.
  ngOnChanges(changes: SimpleChanges | any): void {
    //deconnection
    if (!this.user_ && changes.user_ && changes.user_.previousValue) {
      this.deconnection();
    }
  }

  // ======== si user deconnecté après connexion ========
  deconnection() {
    if (this.tools.checkCurrentPage("product")) {
      setTimeout(() => {
        window.location.reload();
      }, 0);
    }
  }

  // ======== check si user connecté pour calcul si discount ========
  getClient() {
    this.obserUser = this.authService.getUser.subscribe((user: any) => {
      this.user_ = user;
      this.merchantClient = null;
      if (user) {
        if (this.tools.getStor("id_merchant")) {
          this.clientMerchantApi.getMerchantClient().subscribe((client: any) => {
            this.merchantClient = client;
          });
        }
      }
    });
  }

  // ======== observable get product ========
  // Cette fonction "s'abonne" aux changements des produits. Si une autre fonction le demande, 
  // elle relance le refresh des produits en cascade.
  getObserGetProduct() {
    this.obsergetProd = this.prodApi.getobserGetProduct().subscribe((value: any) => {
      if (value) {
        this.getRubricsbySM(this.currSM, "start");
        this.prodApi.setobserGetProduct(null);
      }
    });
  }

  // ======== observable  get ProductSuggestion ========
  // Cette fonction "s'abonne" aux changements des suggestions produits. Si une autre fonction le demande, 
  // elle relance le refresh des produits en cascade.
  getObserLoaderProductSuggestion() {
    this.ObserLoaderProductSuggestion == this.prodApi.getObserLoaderProductsSuggested().subscribe((value: any) => {
      this.loaderpop = value;
      this.loaderTransparent = value ? true : false;
    })
  }

  // ======== Crée un formulaire angular pour la recherche de produit =========
  createSearchProductForm(): void {
    this.searchProductForm = this.formBuilder.group({
      searchProductInput: [""],
    });
    this.searchInputEvent();
  }

  // ========= recherche de produit ========
  searchProduct(searchProd: any) {
    //loader
    this.setSearchProductLoader(true);
    //recupere les produits demandés dynamiquement
    this.prodApi.getProducts_(this.currSM.id, null, null, searchProd, false, this.pricePeriods).then((prod) => {
      //loader
      this.setSearchProductLoader(false);
      //on vide les anciens produits trouvés
      this.setFindedProducts(null);
      if (prod && prod.products && prod.products.length > 0) {
        this.setSearchProductLoader(false, true);
        //on affiche
        this.setFindedProducts(prod.products);
      } else {
        //produit non existant
        this.tools.openSnackBar(this.translate.instant('product.noProduct'), 'warn', 2000);
      }
    })
  }

  // ======== Evenement onKeyUp sur l'input de recherche de produit et le transmet tous les 1.5secondes ========
  // évite que la recherche se lance à chaque input et ne la lance que toutes les 1.5 secondes.
  searchInputEvent(): void {
    let time = 0
    this.searchProductForm.get("searchProductInput").valueChanges.subscribe(() => {
      if (!time) {
        time = 1;
        setTimeout(() => {
          if (this.searchProductForm.get("searchProductInput").value && this.searchProductForm.get("searchProductInput").value.length > 2
            && this.searchProductForm.get("searchProductInput").value.trim().length > 0) {
            //search
            this.searchProduct(this.searchProductForm.get("searchProductInput").value);
          } else if (
            !this.searchProductForm.get("searchProductInput").value || this.searchProductForm.get("searchProductInput").value && this.searchProductForm.get("searchProductInput").value.trim().length == 0
          ) {
            this.resetSearchProduct()
          }
          time = 0;
        }, 1500);
      }
    });
  }

  // Increment le tableau de recherche de produit
  setFindedProducts(value: any): void {
    // console.log("fulle-product.component - setFindedProducts - value : ", value);
    this.findedProducts = value ? value : null;
  }

  // Gere le loader de recherche produit
  setSearchProductLoader(value: boolean, goto?: boolean): void {
    // console.log("fulle-product.component - setSearchProductLoader - value : ", value);
    // console.log("fulle-product.component - setSearchProductLoader - goto : ", goto);
    this.searchProductLoader = value;
    // if (value === false && window.innerWidth < 1279) {
    if (goto) {
      setTimeout(() => {
        this.toggleRubBar ? this.scroollToRubrics() :
          this.scrollToSearchRub();
      });
    }
  }

  // Gere le flag show hide de l'input recherche
  setShowSearchInput(value: boolean): void {
    this.showSearchInput = value;
  }

  // Scroll vers la rubrique de recherche
  scrollToSearchRub(): void {
    const elmnt: any = document.getElementById("searchproductrub");
    elmnt.scrollIntoView({ block: "start", inline: "start" });
  }

  // ======== Handle url params ========
  // Récupère les datas de l'url 
  handleUrlParams(): void {
    const storIdMerchant = this.currIdMerchant;
    const storPos = this.currPos;

    const storBasket = this.currBasket;
    this.route.params.subscribe((params: any) => {
      //si route avec salemethod ou disabled authentification
      this.urlParams = params;
      this.id_webshop_route = params.webshopId;
      /*
      ** En Angular (et dans le navigateur en général), history.state contient des données associées à l’historique de navigation.
      ** Angular ajoute automatiquement un champ navigationId à chaque navigation :
      ** navigationId == 1 → c’est la première navigation vers cette page (chargement initial).
      ** Ensuite, chaque navigation (même sans changement d’URL) incrémente cet ID.
      **
      ** Que fait-il ?
      ** Si on est dans le tout premier chargement de la page (navigationId == 1) :
      ** Alors on utilise pushState pour modifier l’historique de navigation manuellement.
      **
      ** Pourquoi faire ça ?
      ** Cela permet de tricher un peu avec l’historique, notamment pour :
      **  - Empêcher l’utilisateur de revenir trop en arrière avec le bouton "retour" du navigateur, en écrasant le premier état.
      **  - Forcer une navigation "propre" (par exemple, quand Angular n’a pas encore eu le temps de router proprement).
      **  - Ou pour stocker un état personnalisé dans l’historique (ici : navigationId: 2).
      ** Note : le deuxième argument ('note/...') n’est pas l’URL, mais le titre de la page dans l'historique.
      */
      if (history.state && history.state.navigationId == 1) {
        window.history.pushState({ navigationId: 2 }, 'note/' + this.urlParams.merchantName + '/' + this.urlParams.webshopId);
      }

      if (!this.tools.isEmptyObject(params)) {
        if (params.orderId) {
          // Si l’URL contient un orderId : appelle handleOrderUrl() pour récupérer la commande en cours et afficher ses produits.
          this.handleOrderUrl(params, storBasket);
        } else {
          // Sinon, si l’URL contient un webshopId : appelle handleNewUrl() pour récupérer les infos de point de vente liées au webshop.
          // Si celui-ci n'est pas trouvé (ancienne URL ou params incomplets) : appelle handleOldUrl() pour tenter une récupération classique.
          params.webshopId
            ? this.handleNewUrl(params, storBasket, storIdMerchant, storPos)
            : this.handleOldUrl(params, storBasket, storIdMerchant, storPos);
        }
      } else {
        // si aucun paramètre n’est trouvé : vérifie les données du localStorage et redirige éventuellement vers une page 404.
        if (storPos) {
          this.initData();
        } else if (storIdMerchant) {
          this.tools.goPointOfSalePage();
        } else {
          this.router.navigate(["/404", this.translate.instant('error404.Urlincomplet')]);
        }
      }
    });
  }

  // ========  open if archive Salemethod ========
  // si l'user arrive sur cette page depuis une autre méthode de vente (a emporter, webshop, ...)
  // réinitialise la méthode de vente pour la bonne version.
  openInvalidSalemethod() {
    //open dialog sm archivé
    this.myDials.openInvalidSalemethodDial(this.currSM, this.currPos);
    this.myDials.myDialAlertSMDial.afterClosed().subscribe(() => {
      //reset sale_method localstorage

      this.tools.setStor(SalemethodService.TAG_STORAGE, null);
      //redirect
      if (this.urlParams.smId) {
        const url = "/note/" + this.urlParams.merchantName + "/" + this.currPos.webshopId;
        this.router.navigate([url]);
      } else {
        this.initData();
      }
    })
  }

  // ======== Set Current Salemethod ========
  // Si l'utilisateur arrive sur la page avec une URL contenant smId, inId et value,
  // c'est une vente sur une borne ou via un QR code, un lien direct (peut-etre je ne suis pas sur).
  // Alors on prépare un objet `disable_authentification_info_notes` à ajouter à la Salemethod courante.
  SetCurrSm() {
    // Vérifie si des infos d'infonote (inId + value) sont passées via l'URL
    const currSM_disable_authentif_info_notes = this.urlParams.smId && this.urlParams.inId && this.urlParams.value ? 1 : null;

    // Si oui, on les ajoute à l'objet currSM dans une propriété dédiée
    this.currSM.disable_authentification_info_notes = currSM_disable_authentif_info_notes
      ? {
        id: parseInt(this.urlParams.inId),
        value: parseInt(this.urlParams.value),
      }
      : null;

    // Par sécurité, on force la propriété `disable_authentification` à 0 si elle n'existe pas déjà
    this.currSM.disable_authentification = this.currSM.disable_authentification
      ? this.currSM.disable_authentification
      : 0;

    // On enregistre cette SaleMethod comme celle en cours dans l'API
    this.smApi.setSaleMeth(this.currSM, true);

    // Et on vérifie si on est en "mode borne" (terminal de commande autonome)
    this.checkModeborne();
  }

  /**
   * Vérifie si la vente se fait en "mode borne" (ex: borne physique type PayBridge).
   * Si le mode de vente a l'authentification désactivée ET qu'un device PayBridge est détecté dans le localStorage :
   *  - relance la commande automatiquement (sans authentification)
   *  - stocke les paramètres nécessaires (urlParams, point de vente) dans le service borneOrder
   * Sinon, coupe le timeout des commandes sur borne.
   */
  checkModeborne() {
    const devicePaybridge = this.currSM.disable_authentification && this.tools.getStor("devicePaybridge") ? this.tools.getStor("devicePaybridge") : null;
    devicePaybridge ? this.borneOrderService.continueOrder() : this.borneOrderService.removeContinueOrderTimeout()
    if (devicePaybridge && this.currSM && this.currSM.disable_authentification) {
      this.borneOrderService.setParams(this.urlParams);
      this.borneOrderService.setcurpos(this.currPos);
    }
  }

  /**
   * Gère le cas où l'URL contient un `orderId`, donc une commande existante à afficher/reprendre.
   * 
   * Si un panier est déjà présent en localStorage :
   *   → ouvre une popup pour demander confirmation avant d’écraser la commande en cours (`openPrevAllDial`)
   * 
   * Sinon :
   *   → récupère les infos de la commande (`preInitWithOrder`)
   */
  handleOrderUrl(params: any, storBasket: any) {
    if (storBasket) {
      setTimeout(() => {
        this.openPrevAllDial(null, null, params.orderId);
      });
    } else {
      this.preInitWithOrder(params.orderId);
    }
  }

  /**
 * Gère le cas où l'URL contient un ancien format de lien avec un `posId` (point de vente).
 * 
 * Si un panier est présent :
 *   - et que le point de vente en session correspond au `posId` → on initialise directement les données.
 *   - sinon → on ouvre une popup pour confirmer le changement de contexte (`openPrevAllDial`)
 * 
 * Si aucun panier :
 *   → on initialise la session avec les infos de l'URL (`preInit`)
 */
  handleOldUrl(params: any, storBasket: any, storUserId: any, storPos: any) {
    if (storBasket) {
      if (storPos.id === params.posId) {
        this.initData();
      } else {
        this.openPrevAllDial(storUserId, params.posId);
      }
    } else {
      this.preInit(storUserId, params.posId);
    }
  }

  /**
   * Gère les nouvelles URLs avec `webshopId` (identifiant unique de la boutique en ligne).
   * Utilise l'API pour récupérer les clés d'identification (id_marchand, point de vente).
   * 
   * Si un panier est présent :
   *   - et que le marchand et le webshop correspondent → on peut initialiser directement.
   *   - sinon → on affiche la popup pour confirmer un changement de panier (`openPrevAllDial`)
   * 
   * Si aucun panier :
   *   → on initialise avec les nouvelles infos (`preInit`)
   */
  handleNewUrl(params: any, storBasket: any, storIdMerchant: any, storPos: any) {
    this.posApi.$_getUserKeyByWebShopId(params.webshopId, "products").then((keyData: any) => {
      if (storBasket) {
        if (
          storIdMerchant === keyData.object.id_merchant &&
          storPos.id_webshop === params.webshopId
        ) {
          this.initData();
        } else {
          this.openPrevAllDial(
            keyData.object.id_merchant,
            keyData.request.id_point_of_saled
          );
        }
      } else {
        this.preInit(keyData.object.id_merchant, keyData.object.point_of_sale.id_webshop);
      }
    });
  }

  // Init point of sale && call initData
  preInit(id_merchant: any, posId: any): void {
    this.tools.setStor("id_merchant", id_merchant);
    // this.posApi.$_getPointOfsaleById(posId).then((data) => {
    //   console.log("data : ", data)
    //   this.currPos = data[0];
    //   this.posApi.setPoint(data[0]);
    //   this.getClient()
    //   this.initData();
    // });

    // j'ai besoin de :
    // interface ListeDesVarDePoS {
    //   id: number, // '206679' -> id aussi
    //   webshop_analytics_code: string, // 'G-9X9KME8ZEF'
    //   url_encode: string, // 'mon-point-de-vente' -> merchantName dans le route
    //   id_webshop: string, // 'mja2njc5xzy5ngy ->webshopID
    //   onlyOnePOS?: boolean
    // };
    // console.log("id_merchant : ", id_merchant)
    // console.log("this.currPos : ", this.currPos);
    // On cherche si on a un PoS et si celui-ci ne vient pas de Slim, on le remplace par celui de Slim.
    if (!this.currPos || this.currPos.id_webshop) {
      // console.log("this.currPos est null ou a un id_webshop");
      this.fullePointOfSaleService.getPointOfSaleDetails(id_merchant, 'summary, timetables, webshopAnalyticsCode', 'timetables').then((data) => {
        // console.log("data : ", data)
        for (const pos of data) {
          if (pos.idWebshop === this.id_webshop_route) {
            // console.log("pos : ", pos)
            this.currPos = pos;
            this.posApi.setPoint(pos);
            this.getClient();
            this.initData();
            // ajoute les valeurs size au logo et la banniere
            this.logoAndBannerService.initLogoAndBannerDetails(this.currPos).then((enrichedPoint: PointOfSaleDetails) => {
              if (enrichedPoint) {
                this.currPos = enrichedPoint;
              }
            });
            return;
          }
        }
        console.error('id_ws not found');
      });
      ////
    }
  }

  // Handle the case when order id params
  preInitWithOrder(orderId: number) {
    this.loaderMessage = this.translate.instant('loaderText.order');
    // Récupération de la  commande
    this.orderSub = this.orderApi.getOrder(orderId).subscribe((order) => {
      if (!order) {
        this.router.navigate(["/404", this.translate.instant('noOrder')]);
        return;
      }
      this.currencyMng.setCurrCurrency(order.currency);
      // console.log("order : ", order)
      // Récupération du point de vente
      // this.posApi.$_getPointOfsaleById(order.point_of_sale.id_webshop).then((pos) => {
      //   // Récupération du mode de vente
      //   console.log("pos : ", pos)

      //   this.currPos = pos[0];
      //   this.posApi.setPoint(pos[0]);
      //   this.loaderMessage = this.translate.instant('loaderText.sm');
      //   this.smApi.getSaleMethods().subscribe((saleMeths) => {
      //     let flagSm = false;
      //     saleMeths.map((sm: any) => {
      //       if (parseInt(sm.id) === order.sale_method.id) {
      //         flagSm = sm;
      //       }
      //     });
      //     if (flagSm) {
      //       // Récupération des produits
      //       this.smApi.setSaleMeth(flagSm, null);
      //       this.InitProductsAndRubrics(order.sale_method, order);
      //     } else {
      //       this.router.navigate(["/404", this.translate.instant('smnoexist')]);
      //     }
      //   });
      // });
      this.posApi.$_getPointOfsaleById(order.point_of_sale.id_webshop).then((pos) => {
        // Récupération du mode de vente
        // console.log("pos : ", pos)

        this.currPos = pos[0];
        this.posApi.setPoint(pos[0]);
        this.loaderMessage = this.translate.instant('loaderText.sm');
        this.smApi.getSaleMethods().subscribe((saleMeths) => {
          let flagSm = false;
          saleMeths.map((sm: any) => {
            if (parseInt(sm.id) === order.sale_method.id) {
              flagSm = sm;
            }
          });
          if (flagSm) {
            // Récupération des produits
            this.smApi.setSaleMeth(flagSm, null);
            this.InitProductsAndRubrics(order.sale_method, order);
          } else {
            this.router.navigate(["/404", this.translate.instant('smnoexist')]);
          }
        });
      });
    });
  }

  // Init products & rubrics
  InitProductsAndRubrics(saleMethod: any, order?: any, renewProducts?: any): void {
    this.loader = true;
    this.products$ = null;
    this.currSM = saleMethod;
    if (this.currSM) {
      this.smApi.getSaleMethods().subscribe((saleMeths) => {
        const currSm = saleMeths.find((value: any) => value.id == this.currSM.id);
        if (currSm && currSm.archive > 0) {
          this.openInvalidSalemethod();
        } else {
          this.SetCurrSm();
          //au demarrage la dialogue s'ouvre avec le prochain créneau
          if (this.currSM.enable_date_hour && !renewProducts && !order && !this.tools.getStor("date_order")) {
            this.loader = true;
            this.openSelectProductsTimeSlotDial(null);
          } else {
            this.getRubricsbySM(saleMethod, "start");
          }
        }
      })
    }
  }

  setloaderMessage(message?: any, start?: any, rub?: any) {
    if (!message) {
      this.loader = false;
      this.loaderpop = false;
      return;
    }

    let message_loader: any = null;
    switch (message) {
      case 'rub':
        message_loader = this.translate.instant('loaderText.rub');
        break;
      case 'prod':
        message_loader = this.translate.instant('loaderText.prod');
        if (rub && rub.id !== 'all') {
          message_loader += _.lowerCase(rub.name);
        }
        break;
      case 'promo':
        message_loader = this.translate.instant('loaderText.promo');
        break;
      case 'favorite':
        message_loader = this.translate.instant('loaderText.fav');
        break;
      default:
        message_loader = this.translate.instant('loaderText.prog');
    }

    setTimeout(() => {
      start ? this.loader = true : this.loaderpop = true;
      start ? this.loaderMessage = message_loader : this.statusMessage = message_loader;
    }, 0);
  }

  // Récupération de la liste des rubriques pour le mode de vente
  getRubricsbySM(salemethod: any, start?: any) {
    if (salemethod && salemethod.id) {
      this.$limit_from = 0;
      //set loader rub
      this.setloaderMessage("rub", start);
      //recupere les rubriques
      // console.log("getRubricsbySM - this.currPos.id : ", this.currPos.id)
      this.rubApi.getRubricsBySm(salemethod.id, this.currPos.id).subscribe((rubs) => {
        //verifie price_period
        const array_prodData_PricePeriod: any = [];
        this.beforeAddRubrics(salemethod, rubs, array_prodData_PricePeriod, start);
      })
    }
  }

  // Récupération des offres du moment
  //TODO charger en parallèle pour gain de temps
  getProductsPricePeriod(smId: any, pricePeriods: any) {
    const params: any = this.prodApi.getParamsProducts(smId);
    return new Promise(resolve => {
      this.baseclientService.postBaseApi('products_price_periods', params).then(products => {
        // init le stock
        this.prodApi.parsebasketProd(products, pricePeriods).then(parsedProds => {
          resolve(parsedProds);
        });
      });
    });
  }

  beforeAddRubrics(salemethod: any, rubs: any, prodData_PricePeriod: any, start?: any) {
    this.addRubrics(salemethod, rubs, prodData_PricePeriod, null, start);
  }

  // Récupération des articles préférés du client
  getProductsClientFavorite(smId: any, pricePeriods: any) {
    const params: any = this.prodApi.getParamsProducts(smId);
    return new Promise(resolve => {
      this.baseclientService.postBase('clients_products_favorite', params).then(products => {
        // init le stock
        this.prodApi.parsebasketProd(products, pricePeriods).then(parsedProds => {
          resolve(parsedProds);
        });
      });
    });
  }

  addRubrics(salemethod: any, rubs: any, prodData_PricePeriod?: any, prodData_Favorite?: any, start?: any) {
    //ajout rubriques
    const rubrics_favorite = this.rubApi.setRubricsFavorite(rubs, prodData_Favorite);
    const rubrics_prod_promo = this.rubApi.setRubricsPricePeriod(rubrics_favorite, prodData_PricePeriod);
    const rubs_all_parsed = this.rubApi.setRubrics(rubrics_prod_promo);
    this.setRubrics(rubs_all_parsed);
    this.getProducts_(salemethod, null, null, start);
  }

  getValidTimeTables(pointOfSale: any): any[] {
    let validTimeTables = pointOfSale.timetables;
    if (pointOfSale.timetables_sm) {
      for (let index = 0; index < pointOfSale.timetables_sm.length; index++) {
        const timeTable = pointOfSale.timetables_sm[index];
        if (timeTable.id_sale_method === this.currSM.id) {
          validTimeTables = timeTable.timetables;
          break;
        }
      }
    }
    return validTimeTables;
  }

  setHandleblockScrollRubrics(data: any) {
    const timeout = !data ? 500 : 0;
    setTimeout(() => {
      this.blockScrollRubrics = data;
    }, timeout);

  }

  // Récupération des articles en vente
  getProducts_(saleMethod: any, rub?: any, reset?: any, start?: any) {
    if (saleMethod && saleMethod.id) {
      const rubric_id = !rub ? "all" : rub.id;
      this.start = start;
      this.setloaderMessage("prod", start, rub);
      this.prodApi.getProducts_(saleMethod.id, this.$limit_from, rubric_id, null, this.start, this.pricePeriods).then((prodData) => {
        if (start) {
          //au tout debut diplay heure commande
          this.displayDay = prodData.displayDay;
          this.displayHour = prodData.displayHour;
          this.setDisplayDate();
        }
        //on affiche ou pas le button
        this.$more_products_button = prodData.products_to_display > prodData.num_rows ? false : true;
        //on bloque le scroll findrubrique
        this.setHandleblockScrollRubrics(true);
        //on ajoute les produits aux rubriques
        // console.log("fulle-product.component - getProducts_ - this.rubrics$ : ", this.rubrics$)
        // console.log("fulle-product.component - getProducts_ - prodData.products : ", prodData.products)
        // console.log("fulle-product.component - getProducts_ - reset : ", reset)

        const rubrics_prod = this.rubApi.addProdtoRubrics(this.rubrics$, prodData.products, reset);
        // console.log("fulle-product.component - getProducts_ - rubrics_prod : ", rubrics_prod)

        //on set les produits pour l'affichage
        this.setRubrics(rubrics_prod);
        this.newRubricsDisplay$ = rubric_id == "all" ? this.rubrics$ : [this.rubrics$.find((value: any) => value.id == rubric_id)];
        setTimeout(() => {
          this.findIndexRubric(rubric_id);
        }, 0);
        //on ajoute les produits au debut
        if (this.$limit_from == 0) {
          this.products$ = prodData.products;
          this.displayProducts = null;
          this.setloaderMessage(null);
          //scroll
          setTimeout(() => {
            this.mainCompPosition = this.main_container.nativeElement.getBoundingClientRect().top;
            start ? this.scrollToMainCont() : this.scroollToRubrics();
            this.setHandleblockScrollRubrics(false);
          });
        } else {
          //on ajoute aux produits existants
          this.products$.push(prodData.products);
          this.setloaderMessage(null);
          this.setHandleblockScrollRubrics(false);
        }
        //on increment le  prochain limit depart
        this.$limit_from = prodData.next_limit_from;
      });
    }
  }

  getProductsPricePeriod_(saleMethod: any, rub: any) {
    if (saleMethod && saleMethod.id) {
      this.setHandleblockScrollRubrics(true);
      this.setloaderMessage("promo");
      this.getProductsPricePeriod(saleMethod.id, this.pricePeriods).then((prodData_PricePeriod: any) => {
        //parse stock
        this.$more_products_button = false;
        setTimeout(() => {
          //on ajoute les produits aux rubriques
          rub.products = prodData_PricePeriod.products,
            this.setRubrics(this.rubrics$);
          this.newRubricsDisplay$ = [this.rubrics$.find((value: any) => value.id == 'promo')];
          this.findIndexRubric(rub.id);
          this.scroollToRubrics();
        });
        this.setHandleblockScrollRubrics(false);
        this.setloaderMessage(null);
      });
    }
  }

  findIndexRubric(rub_id: any, prov?: any) {
    //evite de bouger le scroll des rubrique lors d'une recherche de produit
    //rub all
    if (rub_id == "all" && !this.start && !prov) {
      const newrub_id = this.tools.getStor("rubric_id_scroll") ? this.tools.getStor("rubric_id_scroll") : null;
      if (newrub_id) {
        return;
      }
    }
    const index_parent = this.rubrics$.find((value: any) => value.id == rub_id);
    const myrubid = index_parent && index_parent.id_parent ? index_parent.id_parent : rub_id;
    const index = this.displayRubrics.findIndex((value: any) => value.id == myrubid);
    if ((index && index > 0) || index === 0) {
      const calc = (index) * 160;
      if (this.listRubrics) {
        this.listRubrics.nativeElement.scrollTo({ left: (calc), behavior: 'smooth' });
      }
      if (this.listRubricsFixed) {
        this.listRubricsFixed.nativeElement.scrollTo({ left: (calc), behavior: 'smooth' });
      }
      this.scrollRubsList = calc * -1;
      this.scrollRubsListFixed = this.scrollRubsList;
      this.arrowsVisibility();
    }
  }

  arrowsVisibility() {
    this.sliderRubFixedArrowLeft = this.listRubricsFixed && this.rubsListFixed && this.listRubricsFixed.nativeElement.clientWidth > this.rubsListFixed.nativeElement.clientWidth ? false : true;
    this.sliderRubFixedArrowRight = this.sliderRubFixedArrowLeft;
    this.sliderRubArrowLeft = this.listRubrics && this.rubsList && this.listRubrics.nativeElement.clientWidth > this.rubsList.nativeElement.clientWidth ? false : true;
    this.sliderRubArrowRight = this.sliderRubArrowLeft;
  }

  // Call initSaleMethod && init categories
  initData(): void {
    this.initSaleMethod();
  }

  // Init sale method && call InitProductsAndRubrics
  initSaleMethod(): void {
    const currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    if (currSm) {
      if (this.urlParams.smId && currSm.id !== parseInt(this.urlParams.smId)) {
        this.openSMDial(this.urlParams.smId, true);
      } else {
        this.angulartics2GoogleAnalytics.pageTrack("product");
        this.InitProductsAndRubrics(currSm);
      }
      this.currSM = currSm;
    } else {
      this.urlParams.smId
        ? this.openSMDial(this.urlParams.smId, true)
        : this.openSMDial();
    }
  }

  // Function event for header && call function InitProductsAndRubrics

  renewProducts($ev?: any) {
    const saleMethod = this.tools.getStor(SalemethodService.TAG_STORAGE);
    this.InitProductsAndRubrics(saleMethod, null, "renewProducts");
  }

  // SCROLL TRICKS

  scrollToMainCont(): void {
    if (this.media.isActive("xs")) {
      this.main_container.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    }
  }

  scroollToRubrics() {
    //search si different lt-lg
    if (!this.toggleRubBar && window.innerWidth < 1279) {
      this.rubProdCont?.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start"
      });
    } else {
      this.Prodrubs.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start"
      });
    }
  }

  slideArrowLeft() {
    const idSearch = "id-" + this.displayRubrics[0].id;
    const elem: any | HTMLElement = document.querySelector('#' + idSearch);
    if (elem) {
      const rect = elem.getBoundingClientRect();
      this.sliderRubArrowLeft = rect.x <= -155 ? true : false;
      this.sliderRubFixedArrowLeft = rect.x <= -155 ? true : false;
    }
  }

  resetSearchProduct() {
    // console.log("fulle-product.component - resetSearchProduct");
    this.findedProducts = null;
    this.searchProductForm.get("searchProductInput").setValue('');
  }

  onClickrubric(rubric: any) {
    // Rubrique sans enfants
    if (rubric.id_parent === 0 && rubric.childs.length === 0) {
      this.findRub(rubric);
    }
  }

  findRub(rub: any): void {
    //on ferme l'input de research
    this.closeSearch = true;
    this.newRubricsDisplay$ = rub.id !== "all" ? [rub] : this.rubrics$;
    this.$limit_from = 0;
    this.resetSearchProduct();
    setTimeout(() => {
      this.closeSearch = false;
    }, 0);
    if (rub.id == "promo") {
      this.getProductsPricePeriod_(this.currSM, rub)
    }
    else if (rub.id == "all") {
      this.getRubricsbySM(this.currSM)
    }
    else {
      this.getProducts_(this.currSM, rub, "reset");
    }
  }

  // ======== moreProducts ========
  moreProducts($rub: any) {
    if ($rub) {
      this.getProducts_(this.currSM, $rub);
    }
  }

  findRub_(rub: any): void {
    //avant
    this.newRubricsDisplay$ = rub.id !== "all" ? [rub] : this.rubrics$;
    // let index = this.rubrics$.findIndex((value: any) => value.id == rub.id);
    const index = this.displayRubrics.findIndex((value: any) => value.id == rub.id);
    if (index && index > 1) {
      this.scrollRubsList = (index - 1) * -160;
      this.scrollRubsListFixed = index * -160;
    }
    let yoffset = rub.id === "all" ? -200 : rub.id === 'promo' ? -200 : -200;
    if (this.media.isActive("xs")) {
      yoffset = rub.id === "all" ? -200 : rub.id === 'promo' ? -110 : -100;
    }

    setTimeout(() => {
      const yOffset = yoffset;
      const element: any = document.getElementById(rub.id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y });
    }, 100);
    this.conditionsArrows();
  }

  scrollRubList(where: string): void {
    this.setHandleblockScrollRubrics(true);
    if (where === "+") {
      this.listRubrics.nativeElement.scrollTo({
        left: (this.listRubrics.nativeElement.scrollLeft - 160),
        behavior: 'smooth'
      });
    } else if (where === "-") {
      this.listRubrics.nativeElement.scrollTo({
        left: (this.listRubrics.nativeElement.scrollLeft + 160),
        behavior: 'smooth'
      });
    }
    this.scrollRubsList = this.listRubrics.nativeElement.scrollLeft * -1;
    this.scrollRubsListFixed = this.scrollRubsList
    this.setHandleblockScrollRubrics(false);
  }

  scrollRubListFixed(where: string): void {
    //mouvement donc scroll
    this.setHandleblockScrollRubrics(true);
    if (where === "+") {
      this.listRubricsFixed.nativeElement.scrollTo({
        left: (this.listRubricsFixed.nativeElement.scrollLeft - 160),
        behavior: 'smooth'
      });
    } else if (where === "-") {
      this.listRubricsFixed.nativeElement.scrollTo({
        left: (this.listRubricsFixed.nativeElement.scrollLeft + 160),
        behavior: 'smooth'
      });
    }
    this.scrollRubsList = this.listRubricsFixed.nativeElement.scrollLeft * -1;
    this.scrollRubsListFixed = this.scrollRubsList
    this.setHandleblockScrollRubrics(false);
  }

  scrollRubList_(where: string): void {
    if (where === "+") {
      this.scrollRubsList += 160;
    } else if (where === "-") {
      this.scrollRubsList -= 160;
    }
    this.scrollRubsListFixed = this.scrollRubsList;
    this.renderer.setStyle(
      this.rubsList.nativeElement,
      "left",
      this.scrollRubsList + "px"
    );
  }

  scrollRubListFixed_(where: string): void {
    if (where === "+") {
      this.scrollRubsListFixed += 160;
    } else if (where === "-") {
      this.scrollRubsListFixed -= 160;
    }
    this.scrollRubsList = this.scrollRubsListFixed;
    this.renderer.setStyle(
      this.rubsList.nativeElement,
      "left",
      this.scrollRubsList + "px"
    );
  }

  detectRubOnScroll(scrollElem: any) {
    let scrollPos = scrollElem && scrollElem.scrollTop ? scrollElem.scrollTop : null;
    const rubProdCont = this.rubProdCont ? this.rubProdCont.nativeElement : null;
    this.scrollPositionY = scrollPos
    /**
     * On boucle sur tous les elements du rub-prod cont
     * Pour chaque element on va checker si le scroll est actuellement dessus
     * Si le scroll est dessus alors on va effectuer une action sur la liste de selection de rubrique
     */
    if (this.newRubricsDisplay$ && this.newRubricsDisplay$.length > 1) {
      if (rubProdCont) {
        for (let i = 0; i < rubProdCont.children.length; i++) {
          const rubElement = rubProdCont.children[i];
          // Si on est tout en bas de la page
          if (!this.toggleRubBar) {
            scrollPos += 100
          }
          if (rubElement.offsetTop <= scrollPos && rubElement.offsetTop + rubElement.offsetHeight > scrollPos) {
            if (rubElement.firstChild && rubElement.firstChild.id) {
              const rubElementId =
                rubElement.firstChild.id.replace("bar-", "")
              if (!this.toggleRubBar) {
                scrollPos -= 100
              }
              //on enregistre la rub
              if (rubElementId) {
                this.tools.setStor("rubric_id_scroll", rubElementId);
                this.findIndexRubric(rubElementId, "more_products");
                break;
              }
            }
            // Si aucune condition correspond alors on déselectionne toutes les rubriques
          } else {
            if (!this.toggleRubBar) {
              scrollPos -= 100
            }
            this.displayRubrics.map(() => {
              // rub.isSelected = false;
            });
          }
        }
      }
    } else {
      if (this.blockScrollRubrics) {
        return;
      }
      if (this.newRubricsDisplay$ && this.newRubricsDisplay$[0] && this.newRubricsDisplay$[0].id) {
        this.findIndexRubric(this.newRubricsDisplay$[0].id)
      }
    }
  }

  // Scroll to the current scroll rub into menu rub
  scrollToCurrentRub(rubIndex: number) {
    const width = this.rubsComp.nativeElement.clientWidth;
    const maxRubByWith = width / 170;
    if (rubIndex + 1 > maxRubByWith) {
      this.scrollRubsListFixed = -((rubIndex + 1 - maxRubByWith) * 170);
    } else {
      this.scrollRubsListFixed = 0;
    }
  }

  //new arrow condition

  // Arrow conditions
  conditionArrowLeft(): void {
    this.sliderRubArrowLeft = this.scrollRubsList < 0
      && this.rubsList.nativeElement.offsetParent.clientWidth <= this.rubsList.nativeElement.scrollWidth ? true : false;
    if (!this.sliderRubArrowLeft) {
      this.slideArrowLeft();
    }
  }

  conditionArrowRight(): void {
    this.sliderRubArrowRight = (this.scrollRubsList + -this.rubsList.nativeElement.offsetParent.clientWidth) > -this.rubsList.nativeElement.scrollWidth
      && this.rubsList.nativeElement.offsetParent.clientWidth <= this.rubsList.nativeElement.scrollWidth ? true : false;
  }

  conditionFixedArrowLeft(): void {
    this.sliderRubFixedArrowLeft = this.scrollRubsListFixed < 0
      && this.rubsListFixed.nativeElement.offsetParent.clientWidth <= this.rubsListFixed.nativeElement.scrollWidth ? true : false;
  }

  conditionFixedArrowRight(): void {
    this.sliderRubFixedArrowRight = (this.scrollRubsListFixed + -this.rubsListFixed.nativeElement.offsetParent.clientWidth) > -this.rubsListFixed.nativeElement.scrollWidth
      && this.rubsListFixed.nativeElement.offsetParent.clientWidth <= this.rubsListFixed.nativeElement.scrollWidth ? true : false;
  }

  conditionsArrows(): void {
    if (this.rubsList) {
      this.conditionArrowLeft();
      this.conditionArrowRight();
    }
    if (this.rubsListFixed) {
      this.conditionFixedArrowLeft();
      this.conditionFixedArrowRight();
    }
  }

  // CHANGE PAGE

  goPos(): void {
    if (!this.currPos.onlyOnePOS) {
      this.tools.goPointOfSalePage();
    }
  }

  goGmap(coord: string[]): void {
    window.open("https://www.google.com/maps/?q=" + coord[0] + "," + coord[1]);
  }

  // Initialise la date de la commande pour l'afficher
  setDisplayDate() {
    this.orderDateHour = {
      day: this.tools.getStor("date_order")
        ? moment(this.tools.getStor("date_order"))
        : moment().isoWeekday(this.displayDay),
      hour: this.tools.getStor("hour_order")
        ? moment(this.tools.getStor("hour_order"))
        : moment(this.displayHour, "HH:mm:ss").isoWeekday(this.displayDay)
    };
  }

  // DIALOGS

  openSMDial(currSmId?: any, fromUrl?: boolean): void {
    const myConf = new MatDialogConfig();
    const closeFlag: boolean = currSmId ? false : true;
    myConf.autoFocus = false;
    myConf.panelClass = "full-screen";
    myConf.disableClose = closeFlag;
    myConf.data = {
      currSmId: currSmId,
      fromUrl: fromUrl,
    };
    this.angulartics2GoogleAnalytics.pageTrack("saleMethods");
    const myDial = this.dialog.open(FulleSalemethodComponent, myConf);
    //changed
    //set la currSmId
    this.tools.setOnPopState(true, currSmId);
    myDial.afterClosed().subscribe((result) => {
      this.angulartics2GoogleAnalytics.pageTrack("product");
      if (result) {
        this.InitProductsAndRubrics(result);
      }
    });
  }

  openProdDial(prod: any, from: string, index?: number): void {
    const myConf = new MatDialogConfig();
    //on copie scrollPositionY à l'ouverture
    this.copyscrollPositionY = _.cloneDeep(this.scrollPositionY);
    // Hide input recherche en xs
    this.setShowSearchInput(false);
    // this.setFindedProducts(null);
    if (this.media.isActive("xs")) {
      myConf.panelClass = "full-screen";
    } else {
      myConf.width = prod.product_type === 2 ? "780px" : "450px";
    }
    myConf.autoFocus = false;
    // recupere les cats par produits
    myConf.data = {
      index: index,
      from: from,
      prod: prod,
      categories: []
    };
    prod.product_type > 0 ? this.getcatProd(myConf, prod) :
      this.openDialProdComp(myConf);
  }

  //recupere les categories
  getcatProd(myConf: any, prod: any) {
    this.loaderpop = true;
    // this.statusMessage = "Récupération des catégories";
    this.statusMessage = this.translate.instant('loaderCats')
    this.prodCatSub = this.prodcatApi.getApiProdCatsByIdProd(prod).subscribe((cats) => {
      cats = this.checkCategories(cats);
      myConf.data.prod.categories = cats;
      myConf.data.prod.novisible = myConf.data.prod.categories && myConf.data.prod.categories.length > 0 ? false : true
      myConf.data.categories = cats;
      this.loaderpop = false;
      this.statusMessage = null;
      this.openDialProdComp(myConf);
    });
  }

  checkCategories(cats: any) {
    const newCats: any = [];
    if (cats && cats.length > 0) {
      cats.forEach((element: any) => {
        const detailsCats: any = []
        if (element && element.details && element.details.length > 0) {
          element.details.forEach((details: any) => {
            if (details.product && details.product.product_type < 2) {
              detailsCats.push(details);
            }
          });
          if (detailsCats && detailsCats.length > 0) {
            element.details = detailsCats;
            newCats.push(element);
          }
        }
      });
    }
    return newCats;
  }

  //ouvre la dialog product
  openDialProdComp(myConf: any) {
    myConf.data.merchantClient = this.merchantClient ? this.merchantClient : null;
    const myDial = this.dialog.open(ProdComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (result) {
        //check if products suggested
        this.prodApi.checkProductsSuggestions(result, this.merchantClient);
      }
      this.checkPopOpen(myDial.getState())
    });
    this.checkPopOpen(myDial.getState())
  }

  openPrevAllDial(id_merchant: any, posId: any, orderId?: any): void {
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.disableClose = true;
    const myDial = this.dialog.open(PreventLossAllComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (result) {
        const old_order_other_etablishment = this.tools.getStor("old_order_other_etablishment");
        this.tools.setStor("id_merchant", old_order_other_etablishment.id_merchant);
        this.tools.setStor("url_encode", old_order_other_etablishment.url_encode);
        //on set l'ancien pof
        this.posApi.$_getUserKeyByWebShopId(old_order_other_etablishment.id_webshop, "products").then((data: any) => {
          this.currPos = data.object.point_of_sale;
          this.posApi.setPoint(data.object.point_of_sale, true);
          this.initData();
        })
      } else {
        orderId ? this.preInitWithOrder(orderId) : this.preInit(id_merchant, posId);
      }
    });
  }

  // Ouvre la popup de selection de créneaux horaire
  openSelectProductsTimeSlotDial(init?: any) {
    this.OpenOnInitDialog = false;
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    if (init) {
      this.OpenOnInitDialog = true;
      myConf.disableClose = true;
      myConf.data = {
        firstOpen: this.OpenOnInitDialog
      }
    }
    this.media.isActive("xs")
      ? (myConf.width = "100%")
      : (myConf.width = "450px");
    const myDial = this.dialog.open(FulleSelectProductsTimeSlotComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      console.log("result : ", result)
      if (result) {
        this.tools.setStor("date_order", result.day);
        this.tools.setStor("hour_order", result.hour);
        this.orderDateHour = {
          day: result.day,
          hour: result.hour
        }
        this.renewProducts();
      }
      this.loader = false;
      this.loaderMessage = "false";
      this.loaderTransparent = false;
      this.OpenOnInitDialog = false;
      //changed
      this.checkPopOpen(false)
    });
    //changed
    this.checkPopOpen(false);
  }

  // Gère l'incrementation des rubriques
  setRubrics(rubs: any): void {
    if (rubs && rubs.length > 0) {
      rubs.forEach((element: any) => {
        if (element.products && element.products.length > 0) {
          element.products.forEach((prod: any) => {
            const ind = rubs.find((value: any) => (value.id == prod.rubric.id));
            if (ind) {
              prod.rubric.enable_menu_suggestion = ind.enable_menu_suggestion;
            }
          });
        }
      });
    }
    this.rubrics$ = rubs;
    this.displayRubrics = rubs.filter((rub: any) => rub.id_parent === 0);
  }

  // Gère l'affichage du panier en mode lt-lg
  openBasket(): void {
    this.toggleBasketResp = !this.toggleBasketResp;
  }

  // Ferme le basket
  closeBasket(): void {
    this.toggleBasketResp = true;
  }

  // SCROLL TRICKS
  @HostListener("window:scroll", ["$event"])
  onScroll(event: any): void {
    const scrollingElement = event.target as HTMLElement
    // Rubrics behavior
    if (this.rubsComp && (scrollingElement &&
      scrollingElement.scrollTop >
      this.rubsComp.nativeElement.offsetTop + 50)
    )
      this.toggleRubBar = false;
    else
      this.toggleRubBar = true;

    // Basket behavior
    if (!this.media.isActive("xs")) {
      this.rememberBasketPos = this.basketComp && this.basketComp.nativeElement.offsetParent
        ? this.basketComp.nativeElement.offsetParent.offsetTop
        : this.rememberBasketPos;
      if (scrollingElement && scrollingElement.scrollTop > this.rememberBasketPos)
        this.toggleBasket = false;
      else
        this.toggleBasket = true;
    }

    // Selection rubric on scroll
    if (!this.findedProducts) {
      // console.log("fulle-product.component - onScroll - !this.findedProducts");

      this.detectRubOnScroll(scrollingElement);
    }
    // Selection produits on scroll
    if (this.rubProdCont && scrollingElement) {
      this.scrollingElementProd = scrollingElement.scrollTop;
    }
  }
}
